// @ts-check
import React from "react"

/**
 * @typedef {Object} FormContainerProps
 * @property {string | undefined} [className]
 * @property {React.ReactNode} children
 */
/**
 * @param {FormContainerProps} props
 * @returns {JSX.Element}
 */
export default function FormContainer({ children, className }) {
  return <div className={`grid formgrid p-fluid ${className}`}>{children}</div>
}
